export enum ExceptionsAmountTypeEnums {
  NOT_USED,
  IN_INTEGER,
  IN_SECONDS,
  IN_DAYS,
  TCID,
  TTID,
  BENEFIT_ID,
  IN_HOURS,
  CARGO_FIELD,
  METRES,
  PUNCH_ID,
}
